import { Injectable } from '@angular/core';
import { HttpClient,HttpErrorResponse,HttpHeaders } from '@angular/common/http';
import { throwError, Observable} from 'rxjs';
import { map} from 'rxjs/operators';
import { catchError } from 'rxjs/operators';
import {Documento} from './model/documento.model';
import { CargaTotales } from './interface/carga_totales.interface';
import { Individual } from './model/individual.model';
import { Totales } from './model/totales.model';


 
@Injectable({
  providedIn: 'root'
})
export class DataService {

envioPdf = '';
consulta = '';
consulta2 = '';
consulta3 = '';
prod = true;
datosDescargados:any;


  documento: Documento[] = [];
    
constructor(private _http: HttpClient) { 

if (this.prod){
this.envioPdf = 'https://flux-data.net/pdf'
this.consulta = 'https://flux-data.net/consulta'
this.consulta2 = 'https://flux-data.net/consulta/all'
this.consulta3 = 'https://flux-data.net/consulta/direccion'
}else{

this.envioPdf = 'http://localhost:8080/pdf'
this.consulta = 'http://localhost:8080/consulta'
this.consulta2 = 'http://localhost:8080/consulta/all'
this.consulta3 = 'http://localhost:8080/consulta/direccion'

}


}
  
   
sendPdf(data:any) {

	
 const headers = new HttpHeaders({
    'Content-Type': 'application/json'
  });
                         return this._http
                         .post<Documento>(this.envioPdf, data, {headers})
                         .pipe(
                           catchError(this.handleError)
                             
                       );
             
                       }

                       

sendConsulta(datosTotales: any) {
   
//console.log("Aqui intentando enviar");

      const headers = {'Content-Type':'application/json'};
                        return this._http
                        .post<Documento>(this.consulta, datosTotales, {headers})
                        .pipe(
                          catchError(this.handleError)
                            
                      );
                          }
sendConsultaAll(datosTotales: any) {

//console.log("Aqui intentando enviar");

		const headers = {'Content-Type':'application/json'};
						return this._http
						.post<Documento>(this.consulta2, datosTotales, {headers})
						.pipe(
							catchError(this.handleError)
							
						);
							}

/*getCuadroMando(mes:string){
	
	const params = {'params':mes};


	return this._http.get<CargaTotales>(this.consulta3, {params})
	.pipe(
		map( resp => {
			console.log(resp);
			this.datosDescargados = resp;
			const total = resp[2].totales.map (
				user => new Totales (user.user, user.count)
		
				//new Individual (user[0].user, user[0].centro, user[0].count);
			);
			const individual = resp[2].individuales.map (
				user2 => new Individual (user2.user, user2.centro, user2.count)
		
				
			);
			return {
				mes:resp[2].mes,
				total,
				individual

			}




		})




	)
}*/

getCuadroMando(mes:string){
	
	const params = {'params':mes};


	return this._http.get<CargaTotales>(this.consulta3, {params})
	.pipe(
		map( resp => {
			//console.log(resp);
			this.datosDescargados = resp;
			
			
			return {
				datosTotales : this.datosDescargados

			}




		})




	)
}


                          
    // Implement a method to handle errors if any
  private handleError(err: HttpErrorResponse | any) {
    console.error('An error occurred', err);
    return throwError(err.message || err);
  }

                 

  
  }
